<script>
  export default {
    name: 'kayak-list-item',
    props: ['item'],
    computed: {
      imagePath () {
        return require("@/assets/images/uploads/kayaks/" + this.item.slug + ".png")
      },
      getKayakDetailPath () {
        return "/kayaks/" + this.item.slug;
      }
    }
  }
</script>
<template>  
  <b-col
    md="6"
    class="mt-5">
    <b-card
      header-bg-variant="dark"
      header-text-variant="white"
      no-body>
      <template #header>
        <h5
          class="mb-0 uppercase">
          {{ item.name }}
        </h5>
      </template>
      <b-card-body>
        <b-card-img
          :src="imagePath">
        </b-card-img>
        <b-card-text
          class="description">
          {{ item.description }}
        </b-card-text>
        <b-list-group
          flush
          class="mt-4"
          style="min-height: 6em;">
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
            v-for="material in item.materials"
            :key="material.id">
            <span
              class="material">
              {{ material.name }}
            </span>
            <b-badge
              variant="light"
              pill>
              {{ material.pricing + " " + material.currencySymbol }}
            </b-badge>
          </b-list-group-item>
        </b-list-group>
        <b-button
          variant="outline-dark"
          class="mt-4"
          style="float: right;"
          :to=getKayakDetailPath>
          Scopri di più
          <b-icon
            icon="arrow-right-short"/>
        </b-button>
      </b-card-body>
    </b-card>
  </b-col>
</template>
<style scoped>
  .description {
    line-height: 1.5em;
    min-height: 3em;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    -webkit-box-orient: vertical;
  }
  .material {
    text-transform: uppercase;
  }
</style>